import { useTranslation } from 'react-i18next';
import { Button } from '@/shared/components';

type Props = {
  total: string;
  isSubmitDisabled: boolean;
  onSubmit: () => void;
};

const ExchangeSectionFooter = ({
  total,
  isSubmitDisabled,
  onSubmit,
}: Props) => {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-[1fr_auto] tablet:grid-cols-2 items-end gap-[0.6rem] p-[0.8rem]">
      <div className="flex flex-col min-w-0">
        <span className="medium5 text-secondary">{t('exchange.total')}</span>
        <span className="hero6 text-foreground truncate">{total}</span>
      </div>
      <Button
        type="button"
        className="w-full min-w-0 tablet:max-w-[22.6rem] tablet:justify-self-end h-[4.4rem] rounded-[1.2rem] px-[3.2rem] headline5 disabled:opacity-100 disabled:bg-secondary-bg disabled:text-tertiary"
        disabled={isSubmitDisabled}
        onClick={onSubmit}>
        {t('personalAccount.overview.actions.exchange')}
      </Button>
    </div>
  );
};

export { ExchangeSectionFooter };
